module.exports = __webpack_public_path__ + "img/c122782382ac23d56649f662c4ecaea2.png";